module.exports = __webpack_public_path__ + "static/github-logo-92f9fc0915dca9cd41ee6f3df9c89314.png";